// 사업자등록번호 포맷 - XXX-XX-XXXXX (3-2-5) 패턴, 입력 중에도 자릿수에 맞춰 점진적으로 하이픈 삽입 //
export function formatBusinessNumber(value) {
  if (!value) return '';

  const digits = String(value).replace(/[^0-9]/g, '').slice(0, 10);

  if (digits.length <= 3) return digits;
  if (digits.length <= 5) return `${digits.slice(0, 3)}-${digits.slice(3)}`;

  return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
}
